export default __webpack_public_path__ + "static/media/loading.0a6ba394.png";